import { buildQueryString, request, serializeCsvQuery } from "../../client"

type PropertyCustomerListQuery = PropertyCustomerQuery & {
  propertyIds?: string[] | null
  customerIds?: string[] | null
}

export const fetchPropertyCustomers = (query?: PropertyCustomerListQuery) =>
  request<PropertyCustomer[]>(
    `/property-customer-registry/property-customers${buildQueryString({
      property_id: query?.propertyId,
      property_ids: serializeCsvQuery(query?.propertyIds),
      customer_id: query?.customerId,
      customer_ids: serializeCsvQuery(query?.customerIds),
      organization_id: query?.organizationId,
    })}`,
  )

export const createPropertyCustomer = (payload: PropertyCustomerCreatePayload) =>
  request<PropertyCustomer>("/property-customer-registry/property-customers", {
    method: "POST",
    body: JSON.stringify(payload),
  })

export const updatePropertyCustomer = (linkId: string, payload: PropertyCustomerUpdatePayload) =>
  request<PropertyCustomer>(`/property-customer-registry/property-customers/${linkId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  })

export const deletePropertyCustomer = (linkId: string) =>
  request<void>(`/property-customer-registry/property-customers/${linkId}`, { method: "DELETE" })
